import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import React from "react";
import HandleUser from "./pages/HandleUser";
import Login from "./pages/Login";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import Fallback from "./components/ErrorBoundary/Fallback";

const Main = () => {
  const token = localStorage.getItem("API_TOKEN");

  return (
    <div className="App">
      {token ? (
        <ErrorBoundary fallback={<Fallback />}>
          <HandleUser />
        </ErrorBoundary>
      ) : (<>
      <AuthenticatedTemplate>
          <ErrorBoundary fallback={<Fallback />}>
            <HandleUser />
          </ErrorBoundary>
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
      </>
        
        
      )}
      
    </div>
  );
};
export default Main;
